import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { algoliaClientNoDupeRequest, INDEX_PRODUCTS, userToken, ALGOLIA_BASE_FILTERS } from 'src/lib/algolia';
import { SearchBarProductHits } from './SearchBarProductHits';

const SearchBarDefaultProducts = ({ collectionHandle, onProductClick }) => {
  const [state, setState] = useState({
    hits: [],
    queryID: null
  });

  const algoliaIndex = useMemo(
    () => algoliaClientNoDupeRequest.initIndex(INDEX_PRODUCTS),
    []
  );

  useEffect(() => {
    algoliaIndex.search('', {
      userToken,
      clickAnalytics: true,
      analyticsTags: ['web', 'search-bar', 'fallback'],
      enableRules: true,
      ruleContexts: [`collection-${collectionHandle}`],
      hitsPerPage: 6,
      filters: `${ALGOLIA_BASE_FILTERS} AND collectionHandles:${collectionHandle}`
    }).then(({ hits, queryID }) => {
      setState({
        hits,
        queryID
      });
    });
  }, [algoliaIndex, collectionHandle]);

  return <SearchBarProductHits {...state} onProductClick={onProductClick} />;
};

SearchBarDefaultProducts.propTypes = {
  collectionHandle: PropTypes.string.isRequired,
  collectionSort: PropTypes.string.isRequired,
  onProductClick: PropTypes.func.isRequired
};

export { SearchBarDefaultProducts };
